import React, {FunctionComponent, useState} from "react";
import './style.scss';
import {useTranslation} from "react-i18next";
import {Download, X} from "react-feather";
import {Button} from "../StyledComponents";
import Platform from "../../models/platforms-data";
import {useNavigate} from "react-router";
import moment from "moment/moment";
import {getNotionLoginUrl} from "../../store/actions";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {isSubUser} from "../../store/selectors";
import {iframeNewTabMsg} from "../../serviceWorker";
import {AddSquare, Card, CloseCircle} from "iconsax-reactjs";
import {
  attentionIcon,
  errorBigIcon,
  iconNotifyAlertTriangle,
  iconNotifySuccess,
  iconNotifyWarningInfo
} from "../../assets/icons/icons";

interface IBadgesProps {
  onClose?: () => void;
  openSetToken?: () => void;
  openHowModal?: () => void;
  progressItem?: string;
  color?: string;
  platformName: string;
  trialDays?: number;
  isComplete?: boolean;
  isExpired?: boolean;
  isSub?: boolean;
  isDash?: boolean;
  isModal?: boolean;
  more?: boolean;
  needAuth?: boolean;
  redirectUrl?: string;
  addingItemsData?: {
    addedItems: number;
    totalItems: number
  }
}


interface IBadgesShortProps {
  action: () => void;
}

const BackupBadges: FunctionComponent<IBadgesProps> = ({
                                                         progressItem,
                                                         platformName,
                                                         onClose,
                                                         isComplete
                                                       }: IBadgesProps) => {
  const {t: translate} = useTranslation();
  const isUserSub = useAppSelector(isSubUser);
  const navigate = useNavigate();

  return (
    <div className='badge badge-success'>
      <div className='badge-content'>
        <div className='badge-icon'>
          {isComplete ?
            <img src={iconNotifySuccess}/> :
            <svg className='rotate-ico' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM9.2 18.46C9.54 16.08 10.6 13.94 12.26 12.26C16.26 8.28 22.56 8.06 26.84 11.54V9.64C26.84 8.82 27.52 8.14 28.34 8.14C29.16 8.14 29.84 8.82 29.84 9.64V14.98C29.84 15.8 29.16 16.48 28.34 16.48H23C22.18 16.48 21.5 15.8 21.5 14.98C21.5 14.16 22.18 13.48 23 13.48H24.5C21.4 11.32 17.12 11.62 14.36 14.38C13.16 15.58 12.4 17.14 12.14 18.88C12.04 19.62 11.4 20.16 10.66 20.16C10.58 20.16 10.52 20.16 10.44 20.14C9.66 20.04 9.08 19.28 9.2 18.46ZM27.74 27.74C25.6 29.88 22.8 30.94 20 30.94C17.56 30.94 15.14 30.08 13.14 28.46V30.34C13.14 31.16 12.46 31.84 11.64 31.84C10.82 31.84 10.14 31.16 10.14 30.34V25C10.14 24.18 10.82 23.5 11.64 23.5H16.98C17.8 23.5 18.48 24.18 18.48 25C18.48 25.82 17.8 26.5 16.98 26.5H15.48C18.58 28.66 22.86 28.36 25.62 25.6C26.82 24.4 27.58 22.84 27.84 21.1C27.96 20.28 28.7 19.7 29.54 19.82C30.36 19.94 30.92 20.7 30.82 21.52C30.46 23.94 29.4 26.08 27.74 27.74Z" fill="#22C55E"/>
            </svg>
          }
        </div>
        <div className='badge-text-block'>
          <div className='badge-title'>
            {isComplete ? progressItem?.replace('in progress...', ' completed.') : progressItem}
          </div>
          <div className='badge-text'>
            {!isComplete ?
              <>
                {`BackupLABS is performing an high-fidelity sync. We are securing your ${Platform[platformName]?.title} ${translate(`views.bulk_restore.itemName.${platformName}.many`)}.`}
                <br/> {!progressItem?.toLowerCase().match('restore') && `You will receive an email once the snapshot is ready.`}
              </> :
              (!progressItem?.toLowerCase().match('restore') ?
              `Your ${translate(`views.bulk_restore.itemName.${platformName}.many`)} is now protected. Daily snapshots are enabled automatically.` :
                `Restore completed.` )
            }
          </div>
        </div>
      </div>
      {!isUserSub && (
        <div className='badge-actions'>
          <Button variant="contained" color="primary" onClick={()=>navigate('/app-connector')}>
            <AddSquare/>
            Add another tool
          </Button>
          {onClose && <CloseCircle className="close-btn" onClick={onClose}/>}
        </div>
      )}
    </div>
  )
}

const BadgesAddingItems: FunctionComponent<Required<Pick<IBadgesProps, 'addingItemsData' | 'platformName' | 'onClose'>>> = ({
                                                                                                                              addingItemsData,
                                                                                                                              platformName,
                                                                                                                              onClose,
                                                                                                                            }: Required<Pick<IBadgesProps, 'addingItemsData' | 'platformName' | 'onClose'>>) => {
  const {t: translate} = useTranslation();

  return (
    <div className={`badge ${addingItemsData.addedItems === addingItemsData.totalItems ? 'badge-success' : 'badge-info'}`}>
      <div className='badge-content'>
        <div className='badge-icon'>
          {addingItemsData.addedItems === addingItemsData.totalItems ?
            <img src={iconNotifySuccess}/> :
            <svg className='rotate-ico' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM9.2 18.46C9.54 16.08 10.6 13.94 12.26 12.26C16.26 8.28 22.56 8.06 26.84 11.54V9.64C26.84 8.82 27.52 8.14 28.34 8.14C29.16 8.14 29.84 8.82 29.84 9.64V14.98C29.84 15.8 29.16 16.48 28.34 16.48H23C22.18 16.48 21.5 15.8 21.5 14.98C21.5 14.16 22.18 13.48 23 13.48H24.5C21.4 11.32 17.12 11.62 14.36 14.38C13.16 15.58 12.4 17.14 12.14 18.88C12.04 19.62 11.4 20.16 10.66 20.16C10.58 20.16 10.52 20.16 10.44 20.14C9.66 20.04 9.08 19.28 9.2 18.46ZM27.74 27.74C25.6 29.88 22.8 30.94 20 30.94C17.56 30.94 15.14 30.08 13.14 28.46V30.34C13.14 31.16 12.46 31.84 11.64 31.84C10.82 31.84 10.14 31.16 10.14 30.34V25C10.14 24.18 10.82 23.5 11.64 23.5H16.98C17.8 23.5 18.48 24.18 18.48 25C18.48 25.82 17.8 26.5 16.98 26.5H15.48C18.58 28.66 22.86 28.36 25.62 25.6C26.82 24.4 27.58 22.84 27.84 21.1C27.96 20.28 28.7 19.7 29.54 19.82C30.36 19.94 30.92 20.7 30.82 21.52C30.46 23.94 29.4 26.08 27.74 27.74Z" fill="#3B82F6"/>
            </svg>
          }
        </div>
        <div className='badge-text-block'>
          <div className='badge-title'>
            {`${addingItemsData.addedItems === addingItemsData.totalItems ? 'Added' : 'Adding'} ${translate(`views.bulk_restore.itemName.${platformName}.many`)}: ${addingItemsData.addedItems} / ${addingItemsData.totalItems} `}
          </div>
        </div>
      </div>
      <div className='badge-actions'>
        {onClose && <CloseCircle className="close-btn" onClick={onClose}/>}
      </div>
    </div>
  )
}
const BadgesTrial2: FunctionComponent<IBadgesProps> = ({
                                                        trialDays = 0,
                                                        platformName,
                                                        color,
                                                        isExpired,
                                                        isSub,
                                                        isModal,
                                                        more
                                                      }: IBadgesProps) => {
  const {t: translate} = useTranslation();
  const navigate = useNavigate();
  const days = Number((Number(trialDays) / 24).toFixed(0) || 0)
  const isUserSub = useAppSelector(isSubUser);

  return (
    <div
      className={('badge ' + (color ? `badge-${color?.replace('_2', '')}` : 'badge-info'))}
      style={isModal ? {padding: '16px', borderRadius: '16px'} : {}}
    >
      <div className='badge-content' >
        {!isModal && (
          <div className='badge-icon'>
            {!color && <img src={attentionIcon} loading="lazy" alt="attention"/>}
            {color === 'warning' && <img src={iconNotifyAlertTriangle}/>}
            {color?.replace('_2', '') === 'error' && <img src={errorBigIcon}/>}
          </div>
        )}
        <div className='badge-text-block'>
          <div className='badge-title' style={{fontSize: isModal ? '14px' : '16px'}}>
            {!color && (
              days ?
                <>{Platform[platformName]?.title}: You have {days} {days > 1 ? 'days' : 'day'} remaining on your free
                  trial</> :
                <>{Platform[platformName]?.title}: Your free trial ends today.</>
            )
            }
            {color === 'warning' &&
              (platformName === 'jira' ?
                  <>Jira: We have detected the number of users on your account has {more ? ' increased' : ' decreased'}.
                    Your subscription will be automatically calculated on renewal.</> :
                  <>You have reached the backup limit on your {isSub ? 'subscription' : 'free trial'}.</>
              )
            }

            {color && ['error', 'error_2'].includes(color) && <>{isSub ? `Subscription expired for ${Platform[platformName]?.title}` : `Free trial expired for ${Platform[platformName]?.title}`}</>}
          </div>
          {isExpired && (
            <div className='badge-text'>
              {color === 'error' && <> {isSub ? 'Your backups have been paused during this grace period. ' : 'Your backups have been paused during this grace period. '} </>}
              {color === 'error_2' && 'Your backups have been removed due to inactivity. '}
              {isSub ? ' Renew your subscription to resume protection.' : 'Buy subscription to resume protection.'}
            </div>
          )}
        </div>

      </div>
      {((color === 'warning' && platformName !== 'jira') || color !== 'warning') && (
        <div className='badge-actions'>
          {!isUserSub && (
            <Button variant="contained" color="primary"
                    onClick={() => {
                      if (platformName === 'shopify') {
                        navigate('/platform/dashboard/shopify-prices-page')
                      } else {
                        localStorage.setItem('checkout-platform', platformName)
                        navigate('/checkout');
                      }
                    }}
                    // style={{minWidth: '120px'}}
            >
              <Card/>
              {
                color === 'warning' ?
                  translate('common.buttons.upgrade') :
                  isExpired ?
                    translate('common.buttons.renew') :
                    translate('common.buttons.subNow')}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

const BadgesSubscription: FunctionComponent<IBadgesProps> = ({
                                                               platformName,
                                                               isModal,
                                                             }: IBadgesProps) => {
  const {t: translate} = useTranslation();
  const navigate = useNavigate();
  const isUserSub = useAppSelector(isSubUser);

  return (
    <div className={'badge badge-info'} style={isModal ? {padding: '16px', borderRadius: '16px'} : {}}>
      <div className='badge-content'>
        {!isModal && (
          <div className='badge-icon'>
            <img src={iconNotifyWarningInfo}/>
          </div>
        )}
        <div className='badge-text-block'>
          <div className='badge-title' style={{fontSize: isModal ? '14px' : '16px'}}>
            {Platform[platformName]?.title}: Your subscription ends today.
          </div>
        </div>
      </div>
      <div className='badge-actions'>
        {!isUserSub && (
          <Button variant="contained" color="primary"
                  onClick={() => {
                    if (platformName === 'shopify') {
                      navigate('/platform/dashboard/shopify-prices-page')
                    } else {
                      localStorage.setItem('checkout-platform', platformName)
                      navigate('/checkout');
                    }
                  }}
                  style={{minWidth: '120px'}}
          >
            <Card/>
            {translate('common.buttons.renew')}
          </Button>
        )}
      </div>
    </div>
  )
}


const BadgesAppWasDeleted: FunctionComponent<IBadgesProps> = ({platformName, redirectUrl}) => {
  const {t: translate} = useTranslation();
  const platform = Platform[platformName];
  const isUserSub = useAppSelector(isSubUser);

  return (
    <div className='badge badge-error'>
      <div className='badge-content'>
        <div className='badge-icon'>
          <img src={errorBigIcon}/>
        </div>
        <div className='badge-text-block'>
          <div className='badge-title'>
            {platform.title}: The app was deleted. All backups are paused until you resume.
          </div>
        </div>
      </div>
      <div className='badge-actions'>
        {!isUserSub && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {window.open(redirectUrl ? redirectUrl : process.env.REACT_APP_GITHUB_APP_INSTALL_URL, '_blank')}}
          >
            <Download/>
            {platformName === 'github' ? translate('forms.github_add_edit_user.github_app') : translate('forms.shopify_add_edit_user.github_app')}
          </Button>
        )}
      </div>
    </div>
  )
}

const BadgesNotionUpd: FunctionComponent<IBadgesProps> = ({onClose, needAuth}: IBadgesProps) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const isUserSub = useAppSelector(isSubUser);
  const dispatch = useAppDispatch();
  const [wait, setWait] = useState<boolean>(false);

  return (
    <>
      {isOpen && (!localStorage['hideNotionMsg'] || (localStorage['hideNotionMsg'] && moment().isSameOrAfter(localStorage['hideNotionMsg']))) && (
        <div className={needAuth ? 'badge badge-error' : 'badge badge-info'}>
          <div className='badge-content'>
            <div className='badge-icon'>
              {needAuth ?
                <img src={errorBigIcon}/> :
                <img src={attentionIcon} loading="lazy" alt="attention"/>
              }
            </div>
            <div className='badge-text-block'>
              <div className='badge-title'>
                {needAuth ?
                  'Notion: We noticed that you have pages in your workspace that are not included in backup. Please, include any newly added pages and teamspaces.' :
                  'Notion: Ensure your backups include any newly added pages and teamspaces.'
                }
              </div>
            </div>
          </div>
          <div className='badge-actions'>
            {!isUserSub && !needAuth && (
              <Button
                variant={needAuth ? "outlined" : "contained"}
                color="primary"
                disabled={wait}
                onClick={() => {
                  if (onClose) {
                    onClose()
                  } else {
                    localStorage['showUpdNotionPopup'] = 'true'
                    navigate('/platform/dashboard/notion')
                  }
                }}
                mr={4}
              >
                Tutorial
              </Button>
            )}
            {needAuth && (
              <Button
                variant="contained"
                color="primary"
                disabled={wait}
                mr={4}
                className="update-notion-btn"
                onClick={async () => {
                  setWait(true)
                  const response = await dispatch(getNotionLoginUrl()).unwrap();
                  window.open(response.url, '_self');
                }}
              >
                UPDATE
              </Button>
            )}
            {!needAuth && (
              <X className="status-badge-right-close"
                 onClick={() => {
                   setIsOpen(false)
                   localStorage['hideNotionMsg'] = moment().add(1, 'd').toJSON()
                 }}
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}

const BadgesJiraError: FunctionComponent<IBadgesProps> = ({isModal}: IBadgesProps) => {

  return (
    <div className='badge badge-warning' style={isModal ? {padding: '16px', borderRadius: '16px'} : {}}>
      <div className='badge-content'>
        <div className='badge-icon'>
          <img src={iconNotifyAlertTriangle}/>
        </div>
        <div className='badge-text-block'>
          <div className='badge-title' style={{fontSize: isModal ? '14px' : '16px'}}>
            Restoring to the same project will result in duplicates. This action is irreversible
          </div>
        </div>
      </div>
    </div>
  )
}

const BadgesIFrameMode: FunctionComponent = () => {

  return (
    <div className='badge badge-info'>
      <div className='badge-content'>
        <div className='badge-icon'>
          <img src={iconNotifyWarningInfo}/>
        </div>
        <div className='badge-text-block'>
          <div className='badge-title'>
            You are using our app from the Jira marketplace. To use all the features, you need to open our app in a new tab.
          </div>
        </div>
      </div>
      <div className='badge-actions'>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            iframeNewTabMsg()
          }}
        >
          Instructions
        </Button>
      </div>
    </div>
  )
}

const BadgesJiraForgeMode: FunctionComponent<IBadgesShortProps> = ({action}) => {

  return (
    <div className='badge badge-info'>
      <div className='badge-content'>
        <div className='badge-icon'>
          <img src={iconNotifyWarningInfo}/>
        </div>
        <div className='badge-text-block'>
          <div className='badge-title'>
            Your Jira account connected via Forge API. You could reconnect your account via our regular API.
          </div>
        </div>
      </div>
      <div className='badge-actions'>
        <Button
          variant="contained"
          color="primary"
          onClick={action}
        >
          Reconnect
        </Button>
      </div>
    </div>
  )
}

export {
  BackupBadges,
  BadgesTrial2,
  BadgesAppWasDeleted,
  BadgesNotionUpd,
  BadgesJiraError,
  BadgesSubscription,
  BadgesAddingItems,
  BadgesIFrameMode,
  BadgesJiraForgeMode
};
